module.exports = __webpack_public_path__ + "img/cua_logo.41628902.jpg";